module.exports = __webpack_public_path__ + "b7a2c20e065be8be.png";